import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import About4 from './../Elements/About4';
import Specialization4 from './../Elements/Specialization4';
import Team3 from './../Elements/Team3';
import AboutSummary from './../Elements/AboutSummary';

var bnrimg = require('./../../images/banner/1.jpg');

const About = () => {
    const [searchParams] = useSearchParams();
    const page = parseInt(searchParams.get('page') || '1', 10);

    return (
        <>
            <Header />
            <div className="page-content">
                <Banner title="Trusted delivery for commercial fit-outs, construction, and network infrastructure." pagename="About Us" bgimage={bnrimg} />
                {page !== 2 && <About4 />}
                {page !== 2 && <Specialization4 />}
                <Team3 />
                <AboutSummary />
            </div>
            <Footer />
        </>
    );
};

export default About;